// extracted by mini-css-extract-plugin
export var checkboxContainer = "FormikInputs-module--checkbox-container--IhXol";
export var checkboxInputSlider = "FormikInputs-module--checkbox-input-slider--It34K";
export var checkboxLabel = "FormikInputs-module--checkbox-label--SB75V";
export var checkmark = "FormikInputs-module--checkmark--ApnpB";
export var error = "FormikInputs-module--error--aRZwz";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var split = "FormikInputs-module--split--7wXJu";
export var switchInfo = "FormikInputs-module--switch-info--polMY";